import './splunk-instrumentation';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {
  BotDetectionUtils,
  tryInitBotDetection,
  botDetectionServiceUiConstants,
  botDetectionChallengeAppearance,
} from './utils/botDetectionHelper';
import { getLogEnvironmentFromHost } from './api/endpoints';

const environmentIsProd = getLogEnvironmentFromHost(window.location.hostname) === 'prod';
const botUtils: BotDetectionUtils | undefined = tryInitBotDetection(
  console.log,
  environmentIsProd ? botDetectionServiceUiConstants.apiKey.prod : botDetectionServiceUiConstants.apiKey.nonProd
);
botUtils?.setChallengeAppearance(botDetectionChallengeAppearance);

botUtils?.loadComplete.finally(() => {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
});
